/* Stride reference rail: keep title, accordion and CTA pinned while media scrolls. */
(() => {
  'use strict';
  const mediaQuery = window.matchMedia('(min-width: 990px)');

  function initialize() {
    document.querySelectorAll('.stride-reference-case').forEach((section) => {
      const aside = section.querySelector('.stride-reference-case__info');
      const rail = section.querySelector('.stride-reference-case__sticky');
      const media = section.querySelector('.stride-reference-case__media');
      if (!aside || !rail || !media || rail.dataset.stridePinReady) return;

      rail.dataset.stridePinReady = 'true';
      let scheduled = false;

      const update = () => {
        scheduled = false;
        if (!mediaQuery.matches) {
          rail.removeAttribute('data-stride-pin');
          return;
        }

        const rect = aside.getBoundingClientRect();
        const panelHeight = rail.getBoundingClientRect().height;
        const headerBar = document.querySelector('.stride-header__bar');
        const headerHeight = headerBar?.getBoundingClientRect().height || 64;
        const top = Math.ceil(headerHeight + 12);
        const style = window.getComputedStyle(aside);
        const leftPad = parseFloat(style.paddingLeft) || 0;
        const rightPad = parseFloat(style.paddingRight) || 0;
        const availableWidth = Math.max(1, rect.width - leftPad - rightPad);

        // Keep the normal layout if the reference is shorter than the rail.
        if (rect.height <= panelHeight + 2) {
          rail.dataset.stridePin = 'natural';
          return;
        }
        if (rect.top > top) {
          rail.dataset.stridePin = 'natural';
          return;
        }
        if (rect.bottom <= top + panelHeight) {
          rail.dataset.stridePin = 'end';
          return;
        }

        rail.style.setProperty('--src-sticky-top', top + 'px');
        rail.style.setProperty('--src-sticky-left', rect.left + leftPad + 'px');
        rail.style.setProperty('--src-sticky-width', availableWidth + 'px');
        rail.dataset.stridePin = 'pinned';
      };

      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', schedule, { passive:true });
      window.addEventListener('resize', schedule, { passive:true });
      window.addEventListener('orientationchange', schedule);
      section.addEventListener('toggle', schedule, true);
      document.addEventListener('shopify:section:load', schedule);

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(schedule);
        observer.observe(media);
        observer.observe(aside);
      }

      schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once:true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();